const PlotFIcon = (props) => (
    <svg
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width='1em'
        height='1em'
        {...props}
    >
        <path
            d="M5.9987 14.6654H9.9987C13.332 14.6654 14.6654 13.332 14.6654 9.9987V5.9987C14.6654 2.66536 13.332 1.33203 9.9987 1.33203H5.9987C2.66536 1.33203 1.33203 2.66536 1.33203 5.9987V9.9987C1.33203 13.332 2.66536 14.6654 5.9987 14.6654Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.88672 7.65984L6.47339 5.59984C6.70005 5.30651 7.12005 5.25318 7.41339 5.47984L8.63339 6.43984C8.92672 6.66651 9.34672 6.61318 9.57339 6.32651L11.1134 4.33984"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11 8.5L8.2 11.3L7.13333 9.7L5 11.8333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.66797 8.5H11.0013V9.83333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PlotFIcon;